"use client"

import dynamic from "next/dynamic"
import { Box, Text } from "@forestsync/ui"
import { useTranslations } from "next-intl"

const MarketChart = dynamic(
  () => import("@/components/trading/MarketChart").then((m) => ({ default: m.MarketChart })),
  {
    ssr: false,
    loading: () => (
      <Box
        h={240}
        bg="var(--mantine-color-default-border)"
        style={{ borderRadius: 8, opacity: 0.3 }}
      />
    ),
  }
)

interface PriceHistoryChartProps {
  bars: Array<{ time: number; value: number }>
}

export function PriceHistoryChart({ bars }: PriceHistoryChartProps) {
  const t = useTranslations("trading")

  if (bars.length === 0) {
    return (
      <Box
        h={240}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid var(--mantine-color-default-border)",
          borderRadius: 8,
        }}
      >
        <Text c="dimmed" size="sm">
          {t("noChartData")}
        </Text>
      </Box>
    )
  }

  return <MarketChart type="area" data={bars as never} height={240} />
}
